export const SORT_ARRAY = (list, by_column) => {
    if (!Array.isArray(list)) return list
    console.log(list);
    return list.sort((a, b) => (a[by_column] > b[by_column]) ? -1 : 1)
}

export const UNLINK_VARIABLE = (variable) => {
    if(!variable) return variable
    return JSON.parse(JSON.stringify(variable))
}
